module.exports = __webpack_public_path__ + "static/mintorganicsetmain-77d9b475b44c4aaf5ecaa6da3d968f48.jpeg";